var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_18909)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 5.31571e-07C4.09276 5.31571e-07 3.41448 0.280952 2.91438 0.781049C2.41428 1.28115 2.13333 1.95942 2.13333 2.66667V2.97173C2.13333 3.4496 2.2752 3.8944 2.51947 4.26667H1.6C1.17565 4.26667 0.768687 4.43524 0.468629 4.7353C0.168571 5.03535 0 5.44232 0 5.86667L0 6.93333C0 7.35768 0.168571 7.76465 0.468629 8.0647C0.768687 8.36476 1.17565 8.53333 1.6 8.53333H7.46667V4.26667H8.53333V8.53333H14.4C14.8243 8.53333 15.2313 8.36476 15.5314 8.0647C15.8314 7.76465 16 7.35768 16 6.93333V5.86667C16 5.44232 15.8314 5.03535 15.5314 4.7353C15.2313 4.43524 14.8243 4.26667 14.4 4.26667H13.4805C13.7248 3.8944 13.8667 3.4496 13.8667 2.97173V2.66667C13.8667 1.95942 13.5857 1.28115 13.0856 0.781049C12.5855 0.280952 11.9072 5.31571e-07 11.2 5.31571e-07C9.84213 5.31571e-07 8.6528 0.725334 8 1.80907C7.66815 1.25694 7.19901 0.800139 6.63824 0.483117C6.07747 0.166096 5.44418 -0.000343278 4.8 5.31571e-07ZM8.53333 4.26667H11.5051C12.2197 4.26667 12.8 3.6864 12.8 2.97173V2.66667C12.8 2.24232 12.6314 1.83535 12.3314 1.5353C12.0313 1.23524 11.6243 1.06667 11.2 1.06667C10.4928 1.06667 9.81448 1.34762 9.31438 1.84772C8.81429 2.34781 8.53333 3.02609 8.53333 3.73333V4.26667ZM7.46667 4.26667H4.49493C3.78027 4.26667 3.2 3.6864 3.2 2.97173V2.66667C3.2 2.24232 3.36857 1.83535 3.66863 1.5353C3.96869 1.23524 4.37565 1.06667 4.8 1.06667C5.15019 1.06667 5.49695 1.13564 5.82049 1.26966C6.14402 1.40367 6.438 1.60009 6.68562 1.84772C6.93324 2.09534 7.12967 2.38931 7.26368 2.71284C7.39769 3.03638 7.46667 3.38314 7.46667 3.73333V4.26667Z",
    fill: "url(#paint0_linear_5_18909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46665 9.59998H1.06665V13.3333C1.06665 14.0406 1.3476 14.7188 1.8477 15.2189C2.3478 15.719 3.02607 16 3.73332 16H7.46665V9.59998ZM8.53332 16H12.2667C12.9739 16 13.6522 15.719 14.1523 15.2189C14.6524 14.7188 14.9333 14.0406 14.9333 13.3333V9.59998H8.53332V16Z",
    fill: "url(#paint1_linear_5_18909)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_18909",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 8.53333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_18909",
    x1: 7.99998,
    y1: 9.59998,
    x2: 7.99998,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0098EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#468EFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_18909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.053f6ddd9171db6e3d010133cd91d86b.svg";
export { ForwardRef as ReactComponent };